import { graphqlDynamic } from "react-apollo-dynamic-query"
import gql from "graphql-tag"
import ListCardBody from "./ListCardBody"
import moment from "moment"
import { connect } from "react-redux"
import { GRAPHQL_DATE_FORMAT } from "../../helpers/sharedConstants"
import PropTypes from "prop-types"

const generateQuery = ({ entityType, childEntityType, bsrCompliance }) => gql`
  query ListCardBody($startAt: String!, $endAt: String!, $entityId: ID!) {
    entity: ${entityType}(id: $entityId) {
      id
      childEntities: ${childEntityType} {
        id
        name
        compliance: ${
          bsrCompliance ? "bsrCompliance" : "roundingCompliance"
        }(startAt: $startAt, endAt: $endAt) {
          timeslices {
            full {
              aggregates {
                overall {
                  compliancePercentage,
                  ${
                    bsrCompliance
                      ? "compliantOpportunityCount"
                      : "compliantRoundCount"
                  },
                  ${bsrCompliance ? "opportunityCount" : "roundCount"},
                }
              }
            }
          }
        }
      }
    }
  }
`

const ListCardBodyWithApollo = graphqlDynamic(generateQuery, {
  options: ({ startAt, endAt, entityId }) => ({
    variables: {
      startAt: startAt.format(GRAPHQL_DATE_FORMAT),
      endAt: endAt.format(GRAPHQL_DATE_FORMAT),
      entityId,
    },
  }),
  props: ({
    data: { loading, error, entity },
    ownProps: { bsrCompliance },
  }) => {
    if (error) {
      throw error
    }
    if (!loading) {
      if (!entity) {
        throw Error("404")
      }

      return {
        data: entity.childEntities.map(item => {
          const aggs = item.compliance.timeslices.full.aggregates.overall
          return {
            ...item,
            compliance: aggs.compliancePercentage,
            opportunities: bsrCompliance
              ? aggs.opportunityCount
              : aggs.roundCount,
          }
        }),
      }
    }
    return { loading, data: [] }
  },
})(ListCardBody)

const ListCardBodyWithData = connect(
  ({
    dateRange: { startDate, endDate },
    bsrCompliance: { bsrCompliance },
  }) => ({
    startAt: moment(startDate),
    endAt: moment(endDate),
    bsrCompliance: bsrCompliance,
  })
)(ListCardBodyWithApollo)

ListCardBodyWithData.propTypes = {
  entityType: PropTypes.oneOf(["facility", "department"]).isRequired,
  entityId: PropTypes.string.isRequired,
  childEntityType: PropTypes.string.isRequired,
  dataSort: PropTypes.string.isRequired,
}

export default ListCardBodyWithData
